import React, { useState } from "react";
import Swal from "sweetalert2"; // Import SweetAlert
import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import { client } from "../../client";
import "./Footer.scss";
import QuickLinks from "./QuickLinks";
import Contact from "../Contact/Contact";

const Footer = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const { username, email, subject, message } = formData;

  // const handleChangeInput = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  // const handleSubmit = () => {
  //   // Validate that all required fields are filled
  //   if (!username.trim() || !email.trim() || !message.trim()) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Missing Information",
  //       text: "Please fill in all required fields!",
  //       confirmButtonColor: "#dc913a",
  //     });
  //     return;
  //   }

  //   // Email validation
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   if (!emailRegex.test(email)) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Invalid Email",
  //       text: "Please enter a valid email address!",
  //       confirmButtonColor: "#dc913a",
  //     });
  //     return;
  //   }

  //   setLoading(true);

  //   const contact = {
  //     _type: "contact",
  //     name: username,
  //     email,
  //     subject: subject || "Contact Form Submission",
  //     message,
  //     submittedAt: new Date().toISOString(),
  //   };

  //   client
  //     .create(contact)
  //     .then(() => {
  //       setLoading(false);
  //       Swal.fire({
  //         icon: "success",
  //         title: "Message Sent!",
  //         text: "Thank you for reaching out! I'll get back to you soon.",
  //         confirmButtonColor: "#dc913a",
  //       });
  //       setFormData({ username: "", email: "", subject: "", message: "" });
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops!",
  //         text: "Something went wrong. Please try again later or contact me directly.",
  //         confirmButtonColor: "#dc913a",
  //       });
  //       console.error("Contact form error:", err);
  //     });
  // };

  return (
    <>
      <Contact />
      {/* <h2 className="head-text">
        Take a <span>coffee</span> & chat with me
      </h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.email2} alt="email" />
          <a href="mailto:momonaim01@gmail.com" className="p-text">
            momonaim01@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.whatsapp} alt="phone" />
          <a
            href="https://wa.me/212652182486"
            className="p-text"
            target="_blank"
            rel="noopener noreferrer"
          >
            +212 652-182486
          </a>
        </div>
      </div>

      <div className="app__footer-form app__flex">
        <div className="app__flex">
          <input
            className="p-text"
            type="text"
            placeholder="Your Name"
            required
            name="username"
            value={username}
            onChange={handleChangeInput}
          />
        </div>
        <div className="app__flex">
          <input
            className="p-text"
            type="email"
            placeholder="Your Email"
            required
            name="email"
            value={email}
            onChange={handleChangeInput}
          />
        </div>

        <div className="app__flex">
          <input
            className="p-text"
            type="text"
            placeholder="Subject"
            required
            name="subject"
            value={subject}
            onChange={handleChangeInput}
          />
        </div>
        <div>
          <textarea
            className="p-text"
            placeholder="Your Message"
            value={message}
            name="message"
            required
            onChange={handleChangeInput}
          />
        </div>
        <button type="button" className="p-text" onClick={handleSubmit}>
          {!loading ? "Send Message" : "Sending..."}
        </button>
      </div> */}
      <QuickLinks />
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg"
);
